<template>
  <el-container class="page">
    <el-main class="no-padding">
      <div class="login"></div>
      <el-row justify="center" type="flex" align="middle">
        <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="6">
          <el-card class="box-card">
            <div slot="header" class="clearfix text-center">
              <img
                src="/img/MaisEnvios_color.png"
                alt="logo"
                height="60px"
              />
            </div>
            <el-form label-position="top">
              <el-alert
                v-show="notvalid"
                type="error"
                effect="dark"
                style="margin-top: 10px; margin-bottom: 10px"
                >Usuário e e-mail não conferem!</el-alert
              >
              <el-row :gutter="25" class="mb-20">
                <el-col :span="24">
                  <el-form-item>
                    <el-input
                      maxlength="80"
                      ref="username"
                      v-model="username"
                      placeholder="Usuário"
                      @keyup.enter.native="$refs.mail.$el.children[1].focus()"
                    >
                      <template slot="prepend">
                        <i class="el-icon-user"></i>
                      </template>
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="25" class="mb-20">
                <el-col :span="24">
                  <el-form-item>
                    <el-input
                      maxlength="80"
                      ref="mail"
                      v-model="mail"
                      placeholder="E-mail"
                      @keyup.enter.native="submit"
                    >
                      <template slot="prepend">
                        <i class="el-icon-message"></i>
                      </template>
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="25">
                <el-col :span="11" :offset="1">
                  <el-button class="w-100" @click="submit()" v-loading="loading" type="primary">ENVIAR</el-button>
                </el-col>
                <el-col :span="11">
                  <el-button class="w-100" @click="back()" type="info">Voltar</el-button>
                </el-col>
              </el-row>
            </el-form>
          </el-card>
        </el-col>
      </el-row>
    </el-main>
  </el-container>
</template>
<script>
import { UserService } from "@/services/users/user.services";

export default {
  methods: {
    back() {
      var vm = this;
      vm.$router.replace({
        name: "login",
      });
    },
    submit: function () {
      var vm = this;
      vm.notauthorization = false;
      vm.notvalid = false;
      if (!vm.username.trim() || !vm.mail.trim()) {
        return vm.$message({ type: "warning", message: "Informe o usuário e o e-mail." });
      }
      vm.loading = true;
      UserService.forget(vm.username, vm.mail)
        .then((response) => {
          vm.$message({
            type: "success",
            message: "E-mail enviado com sucesso!",
          });
        })
        .catch((error) => {
          vm.notvalid = true;
        })
        .finally(() => {
          vm.loading = false;
        });
    },
    enter: function (ev) {
      if (ev.key == "Enter") {
        const vm = this;
        vm.$refs.mail.$el.children[1].focus();
      }
    },
  },
  mounted() {
    const vm = this;
    setTimeout(function () {
      vm.$refs.username.$el.children[1].focus();
    }, 300);
  },
  data() {
    return {
      username: "",
      mail: "",
      loading: false,
      notvalid: false,
    };
  },
};
</script>
<style>
.border-0 {
  margin-top: 50px;
  margin-left: 50px;
}

@media only screen and (min-width: 966px) {
  .border-0 {
    margin-top: 50px;
    margin-left: 10px;
    margin-right: 10px;
  }
}

@media only screen and (max-width: 600px) {
  .border-0 {
    margin-top: 50px;
    margin-left: 10px;
    margin-right: 10px;
  }
}
@media only screen and (min-width: 965px) {
  .page:before {
    flex: 0 1 474px;
  }
}
@media only screen and (min-width: 600px) and (max-width: 965px) {
  .page:before {
    flex: 0 1 274px;
  }
}
@media only screen and (max-width: 600px) {
  .page:before {
    display: none;
  }
}
</style>
